module.exports = __webpack_public_path__ + "static/media/S3N1-4.9856ca12.svg";